import constants from "../../../utils/constants";
import LitcoInfoDialog from "../../UI/LitcoInfoDialog";

export default function NotQualified(props) {
  const { open, onClose } = props;

  return (
    <LitcoInfoDialog open={open} onClose={onClose} title="We Need More Information">
      Unfortunately, we will need to speak with you and get more information prior to booking a consultation. Call{" "}
      <strong key={"notQualifiedNumber"}>
        <a href={"tel:+" + constants.LITCO_NUMBER}>{constants.LITCO_NUMBER}</a>
      </strong>{" "}
      today to speak with a member of our team.
    </LitcoInfoDialog>
  );
}
